import {doc} from './docs.js';

doc(
    'haptic.vibrate',
    {
        'ms': 'milliseconds to vibrate'
    },
    "Vibrates on mobile for specified time"
);

export const haptic_vibrate = (object) => {
    return ([ms]) => {
        if ('vibrate' in navigator) {
            navigator.vibrate(ms);
        }
    };
};
